<bom-full-page [show]="show$ | async">
  <ng-container bom-fullpage-main>
    <p class="text">
      {{
        'TimeoutComponent.TokenExpiresIn'
          | tekstresource: { duration: tokenExpiresInString$ | async }
      }}
    </p>
    <button #buttonStayActive class="button button-primary" (click)="stayActiveClicked()">
      {{ 'Continue' | tekstresource }}
    </button>
  </ng-container>
</bom-full-page>
